module.exports = __webpack_public_path__ + "img/15.b51dd262.jpg";